import http from '../http/http';

import { CREATE_BY_INVITE, generateEndpoint } from '../http/endpoints';

export default (() => {
    const createByInvite = (params) =>
        http.post(generateEndpoint(CREATE_BY_INVITE), params);

    return {
        createByInvite,
    };
})();
